<!--主页的学会通知卡片-->
<template>
  <div class="ann_box" @mouseover="overok=true" @mouseleave="overok=false" >
    <div :class="{containerchange2:overok}" style="width: calc(100%);float: left;padding-top: 8px;padding-left: 5px;padding-right: 5px;display: flex;flex-direction: column;">
      <div style="min-height: 200px;overflow: hidden;width: 100%;height: 50%;"><!--src="../../assets/img/news1.png"-->
        <img style="width: 100%" :src="imgsrc">
      </div>
      <div class="ann_container" :class="{containerchange:overok}">
        <div style="height: 80%;width: 100%;min-height: 105px;">
          <p class="newitem-title" style="font-size: 12px">
            <router-link style="color: #000000" :to="'/noticeArticle/'+articleId+'/'+tabName" class="itemNotice-a">{{title}}</router-link>
          </p>
          <p class="newitem-text" style="font-size: 12px" v-html="annTest"></p>
        </div>
        <div style="max-height: 46px;margin-left: 5px">
          <router-link style="color:#337ab7" :to="'/noticeArticle/'+articleId+'/'+tabName" class="itemNotice-a">
            <button class="noticeBtn btn btn-sm">查看详情</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import coverImg from '../../assets/img/img.png'
export default {
  props: {
    annDay: {},
    annData: {},
    annTest: {},
    articleId: {},
    tabName: {},
    title: {},
    cover: {}
  },
  data () {
    return {
      coverImg: '../../assets/img/img.png',
      overok: false
    }
  },
  computed: {
    imgsrc () {
      if (this.cover) return this.cover
      else return coverImg
    }
  }
}
</script>

<style>
  .ann_box{
    width: calc(30%);
    margin: 5px 5px;
    height: 385px;
    background-color: #f2f2f2;
    float: left;
    border-bottom: 1px solid #ffffff;
    border-right: 1px solid #ffffff;
    margin-left: 28px;
  }
  .ann_container{
    padding: 8px;
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 45%;
  }
  .newitem-title{
    width: 100%;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
  }
  .newitem-title a{
    display: block;
    white-space: nowrap;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .newitem-text{
    width: 280px;
    margin-bottom: 8px;
    font-size: 11px;
    line-height: 24px;
    color: #797979;
  }
  .newitem-text a{
    color: #ffffff;
  }
  .noticeBtn{
    margin-bottom: 30px;
    background-color: #929292;
    color: #ffffff;
  }
  .noticeBtn :active{
    margin-bottom: 30px;
    background-color: #ffffff;
    color: #929292;
  }
  .containerchange{
    /* background-color: rgb(27,90,166); */
  }
  .containerchange2{
    box-shadow: 3px 3px 16px rgba(0,0,0,0.4);
    transform: scale(1.07);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/announcementNew.vue